

let flavorNotesSwiper;
let updating = false;
let isFinished = false;

var windowWidth = document.documentElement.clientWidth || window.innerWidth;


function initFlavorNotesSwiper() {
  flavorNotesSwiper = new Swiper(".fum-flavor-notes-carousel", {

    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 0,
    coverflowEffect: {
      rotate: 10,
      stretch: 30,
      depth: 500,
      slideShadows: false,
    },

    navigation: {
      nextEl: ".fum-flavor-notes-carousel-button-next",
      prevEl: ".fum-flavor-notes-carousel-button-prev",
    },

    initialSlide: 3,
    on: {
     
 
      slideChange: () => {
        flavorNotesIndicatorSectionController();
        logCenteredSlide()
      
      },
    },
  });
  logCenteredSlide()
  flavorNotesIndicatorSectionController()
 
}


function logCenteredSlide() {
  if (
    flavorNotesSwiper &&
    flavorNotesSwiper.slides &&
    flavorNotesSwiper.slides.length > 0
  ) {
   // Remove the 'fum-flavor-notes-slide-active' class from the previous active slide
    const previousActiveSlide = document.querySelector('.fum-flavor-notes-slide-active');
    if (previousActiveSlide) {
      previousActiveSlide.classList.remove('fum-flavor-notes-slide-active');
    }

    // Get the current active slide
    const activeSlide = flavorNotesSwiper.slides[flavorNotesSwiper.activeIndex];

    // Add the 'fum-flavor-notes-slide-active' class to the new active slide
    if (activeSlide) {
      activeSlide.classList.add('fum-flavor-notes-slide-active');
    
    }


  }
}

const flavorNotesIndicatorSectionController = () => {
  if (
    flavorNotesSwiper &&
    flavorNotesSwiper.slides &&
    flavorNotesSwiper.slides.length > 0
  ) {

    
    // Indicator Elements
    const indicatorCommentEl = document.getElementById(
      "fum-flavor-notes-indicator-comment"
    );
    const indicatorCommentEl2 = document.getElementById(
      "fum-flavor-notes-indicator-comment-2"
    );
    const indicatorShopBtnEl = document.getElementById(
      "fum-flavor-notes-indicator-shopbtn"
    );
    const indicatorRemarksEl = document.getElementById(
      "fum-flavor-notes-indicator-remarks"
    );
    const indicatorPersonLocationEl = document.getElementById(
      "fum-flavor-notes-indicator-personlocation"
    );
    const indicatorPersonLocationEl2 = document.getElementById(
      "fum-flavor-notes-indicator-personlocation-2"
    );
    const indicatorPersonNameEl = document.getElementById(
      "fum-flavor-notes-indicator-personname"
    );
    const indicatorPersonNameEl2 = document.getElementById(
      "fum-flavor-notes-indicator-personname-2"
    );
    const indicatorVerifiedPurchaseEl = document.getElementById(
      "fum-flavor-notes-indicator-verified"
    );
    const indicatorVerifiedPurchaseEl2 = document.getElementById(
      "fum-flavor-notes-indicator-verified-2"
    );
    const indicatorFlavorRatingCriteria1 = document.getElementById(
      "fum-flavor-notes-flavorrating-criteria1"
    );
    const indicatorFlavorRatingCriteria2 = document.getElementById(
      "fum-flavor-notes-flavorrating-criteria2"
    );
    const indicatorFlavorRatingCriteria3 = document.getElementById(
      "fum-flavor-notes-flavorrating-criteria3"
    );

    flavorNotesSwiper.slides.forEach((slide, index) => {
      if (index == flavorNotesSwiper.activeIndex) {
        const comment = slide.getAttribute("data-indicator-comment");
        const personName = slide.getAttribute("data-indicator-personname");
        const personLocation = slide.getAttribute(
          "data-indicator-personlocation"
        );
        const verifiedPurchase = slide.getAttribute(
          "data-indicator-verifiedpurchase"
        );
        const remarks = slide.getAttribute("data-indicator-remarks");
        const productName = slide.getAttribute("data-indicator-productName");
        const flavorRatingSvg = {
            0: "//tryfum.com/cdn/shop/t/173/assets/FUM_FlavorRating_0_3.svg?v=175993732040427659141790551030",
          1: "//tryfum.com/cdn/shop/t/173/assets/FUM_FlavorRating_1_3.svg?v=21783373565857038781790551030",
          2: "//tryfum.com/cdn/shop/t/173/assets/FUM_FlavorRating_2_3.svg?v=159980391442146076481790551030",
          3: "//tryfum.com/cdn/shop/t/173/assets/FUM_FlavorRating_3_3.svg?v=80597186736480490511790551030",
        };

        indicatorCommentEl.innerText = '"' + comment + '"';
        indicatorCommentEl2.innerText = '"' + comment + '"';
        indicatorPersonNameEl.innerText = personName;
        indicatorPersonNameEl2.innerText = personName;
        indicatorPersonLocationEl.innerText = personLocation;
        indicatorPersonLocationEl2.innerText = personLocation;
        indicatorRemarksEl.innerText = remarks;
        indicatorShopBtnEl.innerText = "Shop " + productName;

        // verifiedPurchase
        if (verifiedPurchase?.toLowerCase() == "true") {
          indicatorVerifiedPurchaseEl.style.visibility = "visible";
          indicatorVerifiedPurchaseEl2.style.visibility = "visible";
        } else {
          indicatorVerifiedPurchaseEl.style.visibility = "hidden";
          indicatorVerifiedPurchaseEl2.style.visibility = "hidden";
        }

        // flavorRatingCriteria
        // Iterate through the potential indices
        let i = 0;
        while (true) {
          const rating = slide.getAttribute(
            `data-indicator-flavorrating-criteria[${i}]`
          );
          if (rating === null) {
            // Break the loop if no more criteria found
            break;
          }

          switch (i) {
            case 0:
              indicatorFlavorRatingCriteria1.src =
                flavorRatingSvg[parseInt(rating, 10)];
              break;
            case 1:
              indicatorFlavorRatingCriteria2.src =
                flavorRatingSvg[parseInt(rating, 10)];
              break;
            case 2:
              indicatorFlavorRatingCriteria3.src =
                flavorRatingSvg[parseInt(rating, 10)];
              break;
          }

          // Convert the string value to integer and push to array
          // flavorRatingCriteria.push(parseInt(rating, 10));
          i++;
        }
      }
    });
  }
};

function flavorNotesSlideToIndex(index) {
  flavorNotesSwiper.slideToLoop(index);
}

const coreFlavors = [
  { flavor: "Raspberry Lemon", sweetness: 1, throatHit: 0, savoury: 2 },
  { flavor: "White Cranberry", sweetness: 2, throatHit: 1, savoury: 2 },
  {
    flavor: "Sparkling Grapefruit",
    sweetness: 1,
    throatHit: 2,
    savoury: 1,
  },
  { flavor: "Orange Vanilla", sweetness: 2, throatHit: 0, savoury: 1 },
  { flavor: "Maple Pepper", sweetness: 2, throatHit: 2, savoury: 3 },
  { flavor: "Spearmint Ice", sweetness: 2, throatHit: 3, savoury: 0 },
  { flavor: "Cinnamon Hearts", sweetness: 3, throatHit: 1, savoury: 1 },
  { flavor: "Black Licorice", sweetness: 3, throatHit: 2, savoury: 2 },
  { flavor: "Crisp Mint", sweetness: 0, throatHit: 3, savoury: 1 },
  { flavor: "Peach Blush", sweetness: 2, throatHit: 1, savoury: 0 },
];

function flavorNotesLogCenteredSlideId() {
  if (
    flavorNotesSwiper &&
    flavorNotesSwiper.slides &&
    flavorNotesSwiper.slides.length > 0
  ) {
    const centeredSlide =
      flavorNotesSwiper.slides[flavorNotesSwiper.activeIndex];
    const centeredSlideId = centeredSlide.id;
    const flavorObject = coreFlavors.find(
      (flavor) => flavor.flavor === centeredSlideId
    );
    if (flavorObject) flavorNotesUpdateFlavorIndicators(flavorObject);
  }
}

function flavorNotesUpdateFlavorIndicators(flavorObject) {
  flavorNotesUpdateDots(
    ".indicator:nth-child(1) .dots",
    flavorObject.sweetness
  );
  flavorNotesUpdateDots(".indicator:nth-child(2) .dots", flavorObject.savoury);
  flavorNotesUpdateDots(
    ".indicator:nth-child(3) .dots",
    flavorObject.throatHit
  );
}

function flavorNotesUpdateDots(selector, value) {
  const dots = document.querySelectorAll(`${selector} .dot`);
  dots.forEach((dot, index) => {
    dot.classList.toggle("red", index < value);
    dot.classList.toggle("blush", index >= value);
  });
}

let flavorItems = [];

function handleFlavorNotesBlockClick(index, element) {
  if (flavorItems.includes(index)) {
    flavorItems = flavorItems.filter((item) => item !== index);
    element.classList.remove("selected");
  } else {
    if (flavorItems.length >= 2) {
      const firstItem = flavorItems.shift();
      document
        .querySelector(`.fum-flavor-notes-block[data-index="${firstItem}"]`)
        .classList.remove("selected");
    }
    flavorItems.push(index);
    element.classList.add("selected");
  }

  if (flavorItems.length === 2) {
    const randomNumber = flavorNotesGetRandomNumber();
    flavorNotesSlideToIndex(randomNumber);
  }
}

function flavorNotesGetRandomNumber() {
  return Math.floor(Math.random() * 9);
}

   function flavorNotesGoToNextSlide() {
        flavorNotesSwiper.slideNext();
      }

      function flavorNotesGoToPrevSlide() {
        flavorNotesSwiper.slidePrev();
      }


document.querySelectorAll(".fum-flavor-notes-block").forEach((block) => {
  block.addEventListener("click", function () {
    handleFlavorNotesBlockClick(this.getAttribute("data-index"), this);
  });
});

document.addEventListener("DOMContentLoaded", initFlavorNotesSwiper);





